import { useEffect, useSyncExternalStore } from "react";
import type * as OutfitModule from "./Outfit.tsx";

/**
 * The outfit drawings load on demand (first-load budget, SPEC 14): a bee wearing something draws
 * itself plainly for a moment, then with its outfit once this chunk has arrived.
 */
type Art = typeof OutfitModule;

let art: Art | null = null;
let loading: Promise<void> | null = null;
const listeners = new Set<() => void>();

function load() {
  loading ??= import("./Outfit.tsx").then(
    (m) => {
      art = m;
      listeners.forEach((fn) => fn());
    },
    () => {
      loading = null; // offline: try again with the next bee
    },
  );
}

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

export function useOutfitArt(needed: boolean): Art | null {
  const current = useSyncExternalStore(subscribe, () => art);
  useEffect(() => {
    if (needed && !art) load();
  }, [needed]);
  return current;
}
